module.exports = __webpack_public_path__ + "static/img/desc4.ece2477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desc4.png
// module id = 6kMg
// module chunks = 1